<template>
  <div class="common-use">
    <navbar :title="title" left-text show-home></navbar>
    <div class="search" v-if="showSearch">
      <div class="searchWrap">
        <button @click="onSearch" class="search-bar">
          <img alt src="../../assets/img/home/search-icon.png" />
          <span>搜索</span>
        </button>
      </div>
    </div>
    <div class="banner" v-if="columnInfo.banner && columnInfo.banner.url">
      <img alt v-lazy="columnInfo.banner.url" />
    </div>
    <div class="common-use-wrapper" v-show="goodsList.length">
      <van-list
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
        v-model="loading"
      >
        <div class="product-list">
          <product-list :sku-list="goodsList"></product-list>
        </div>
      </van-list>
    </div>
    <div class="no-data" v-show="noData && !goodsList.length">
      <img src="../../assets/img/nodata.png" />
      <p>商品进货中…</p>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import Navbar from '../../components/NavBar'
import ProductList from '../../components/ProductDoubleEach'
import api from '../../utils/api'
let flag = false
export default {
  name: 'page-column',
  components: {
    Navbar,
    VanList: List,
    ProductList
  },
  data () {
    return {
      showSearch: false,
      cid: null,
      goodsid: null,
      skuid: null,
      title: '',
      columnInfo: {},
      pageTitle: '',
      goodsList: [],
      loading: false,
      finished: false,
      pageNum: 1,
      noData: false,
      firstGoods: false
    }
  },
  created () {
    this.$toast.loading('正在加载...')
    this.cid = this.$route.query.column
    this.goodsid = this.$route.query.goodsid
    this.skuid = this.$route.query.skuid
    this.getCurrentSku()
    this.getColumnInfo()
  },
  mounted () {
    let csid = []
    csid.push(this.$route.query.column)
    sessionStorage.setItem('csid', JSON.stringify(csid))
  },
  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getGoodsList(++this.pageNum).then(() => {
          setTimeout(() => {
            this.loading = false
            flag = false
          }, 500)
        })
      }, 500)
    },
    onSearch () {
      this.$router.push({ name: 'searchPages', query: { title: this.pageTitle } })
    },
    /**
     * 获取店铺信息
     */
    async getColumnInfo () {
      const res = await this.$axios.get(`api/goods/channel/${this.cid}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.columnInfo = data.template_elements
          this.title = this.columnInfo.shoptitle
          this.pageTitle = this.$route.query.title
          let pageTitles = ['消费帮扶', '办公用品', '劳保用品', '防疫物资', '防暑降温', '优选好货']
          if (pageTitles.includes(this.pageTitle)) {
            this.showSearch = true
          }
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取选中sku
     */
    async getCurrentSku () {
      if (!this.goodsid || !this.skuid) {
        this.getGoodsList()
        return false
      }
      const res = await this.$axios.get(`/api/goods/detail/${this.goodsid}/${this.skuid}`)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.firstGoods = data
          this.getGoodsList()
        } else {
          this.$toast(msg)
        }
      }
    },
    /**
     * 获取商品类表
     */
    async getGoodsList (pageNum) {
      const res = await api.getProductList({ id: this.cid, pageNum, skuid: this.skuid })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          if (pageNum === 1 || !pageNum) {
            this.goodsList = this.firstGoods ? [this.firstGoods, ...this.goodsList, ...data] : [...this.goodsList, ...data]
          } else {
            this.goodsList = [...this.goodsList, ...data]
          }
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  },
  activated () {
    // || this.skuid % this.$route.query.skuid !== 0
    if (this.cid % this.$route.query.column !== 0) {
      let csid = []
      csid.push(this.$route.query.column)
      sessionStorage.setItem('csid', JSON.stringify(csid))
      this.showSearch = false
      this.cid = this.$route.query.column
      this.skuid = this.$route.query.skuid
      this.goodsid = this.$route.query.goodsid
      this.columnInfo = {}
      this.pageNum = 1
      this.noData = false
      this.finished = false
      this.goodsList = []
      this.firstGoods = false
      this.$toast.loading('正在加载...')
      this.getColumnInfo()
      this.getCurrentSku()
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  width: 100%;
  height: 0.88rem;
  padding: 0.14rem 0.24rem;
  box-sizing: border-box;
  background-color: #343a4b;
  text-align: center;
  font-size: @fz24;
  color: @c80;
}
.searchWrap {
  position: fixed;
  left: 0;
  top: 0.88rem;
  z-index: 999;
  width: 100%;
  height: 0.88rem;
  padding: 0.14rem 0.24rem;
  box-sizing: border-box;
  background-color: #343a4b;
  text-align: center;
  font-size: @fz24;
  color: @c80;
  .search-bar {
    width: 100%;
    height: 0.6rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 30px;
    img {
      width: 0.3rem;
      object-fit: contain;
      padding-left: 0.2rem;
      padding-right: 0.1rem;
    }
  }
}
.banner {
  width: 100%;
  height: 2.4rem;
  img {
    object-fit: contain;
  }
}
.product-list {
  padding: 0 0.2rem 0.2rem;
  display: flex;
  justify-content: space-between;
}
.no-data {
  width: 2.68rem;
  height: 2.53rem;
  margin: 0 auto;
  padding-top: 2.33rem;
  font-size: @fz28;
  color: @c80;
  text-align: center;
  p {
    padding-top: 0.24rem;
  }
}
</style>
